import React from "react";
import ShopCard from "./ShopCard";

/**
 * Rejilla de tarjetas de tienda.
 *
 * El acordeón por tarjeta ya no hace falta: la tarjeta rediseñada muestra sus
 * datos siempre, así que no hay nada que desplegar. El estado vacío lo pinta
 * `Shops.jsx`, que es quien sabe si la lista está vacía o es un filtro.
 */
const ShopCardGrid = ({
  cards,
  handleUpdate,
  handleDelete,
  selectedIds = [],
  onToggleSelect,
  handleManageBilling,
  handleCancelSubscription,
  handleStartBilling,
  handleStartSetup,
}) => (
  <div className="grid grid-cols-1 items-stretch gap-4 sm:grid-cols-2 sm:gap-5 lg:grid-cols-3 lg:gap-6">
    {cards.map((card) => (
      <ShopCard
        key={card.id}
        id={card.id}
        name={card.name}
        address={card.address}
        city={card.city}
        postalCode={card.postal_code}
        venueType={card.venue_type}
        planTier={card.plan_tier}
        activationStatus={card.activation_status}
        subscriptionStatus={card.subscription_status}
        shop_owners={card.owners}
        shopImage={card.image_path}
        date_created={card.date_created}
        handleUpdate={handleUpdate}
        handleDelete={handleDelete}
        selectedIds={selectedIds}
        onToggleSelect={onToggleSelect}
        handleManageBilling={handleManageBilling}
        handleCancelSubscription={handleCancelSubscription}
        handleStartBilling={handleStartBilling}
        handleStartSetup={handleStartSetup}
      />
    ))}
  </div>
);

export default ShopCardGrid;
